// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    0,
    0,
    0,
    0,
    0
  ],
  "2": [
    0,
    {
      "sub": "法学前沿",
      "tec": "刘岩",
      "week": "3-10周",
      "add": "教学楼D座225经管"
    },
    0,
    0,
    0
  ],
  "3": [
    0,
    {
      "sub": "仲裁法",
      "tec": "赵君",
      "week": "1-8周",
      "add": "教学楼D座225经管"
    },
    0,
    0,
    0
  ],
  "4": [
    0,
    0,
    0,
    0,
    0
  ],
  "5": [
    0,
    0,
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
